import { createSlice } from '@reduxjs/toolkit';
import { getGlobalSearch, amazonSearchTable, amazonSearch } from 'services/actions/searchAction';
import { addTemplateManager, getTemplateDetail, getTemplates, removeTemplateManager, getTemplateCat } from 'services/actions/templateManagerAction';

interface TemplateState {
    loading: boolean;
    templateInfo: any;
    error: any;
    success: boolean;
    loading1: boolean;
    addTempMngrInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    rmvTempMngrInfo: any;
    error2: any;
    success2: boolean;
    loading3: boolean;
    success3: boolean;
    error3: any;
    tempDetailInfo: any;

    getTemplateCatLoading: boolean;
    getTemplateCatInfo: any;
    getTemplateCatError: any;
    getTemplateCatSuccess: boolean;
}

const initialState: TemplateState = {
    loading: false,
    templateInfo: null,
    error: null,
    success: false,
    loading1: false,
    addTempMngrInfo: null,
    error1: null,
    success1: false,
    loading2: false,
    rmvTempMngrInfo: null,
    error2: null,
    success2: false,
    loading3: false,
    error3: null,
    success3: false,
    tempDetailInfo: null,

    getTemplateCatLoading: false,
    getTemplateCatInfo: null,
    getTemplateCatError: null,
    getTemplateCatSuccess: false,
};

const templateSlice = createSlice({
    name: 'templates',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTemplates.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.templateInfo = null;
            })
            .addCase(getTemplates.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.templateInfo = payload;
                state.success = true;
            })
            .addCase(getTemplates.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(addTemplateManager.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.addTempMngrInfo = null;
            })
            .addCase(addTemplateManager.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.addTempMngrInfo = payload;
                state.success1 = true;
            })
            .addCase(addTemplateManager.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(removeTemplateManager.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.rmvTempMngrInfo = null;
            })
            .addCase(removeTemplateManager.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.rmvTempMngrInfo = payload;
                state.success2 = true;
            })
            .addCase(removeTemplateManager.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(getTemplateDetail.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.tempDetailInfo = null;
            })
            .addCase(getTemplateDetail.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.tempDetailInfo = payload;
                state.success3 = true;
            })
            .addCase(getTemplateDetail.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            })
            .addCase(getTemplateCat.pending, (state) => {
                state.getTemplateCatLoading = true;
                state.getTemplateCatError = null;
                state.getTemplateCatSuccess = false;
                state.getTemplateCatInfo = null;
            })
            .addCase(getTemplateCat.fulfilled, (state, { payload }) => {
                state.getTemplateCatLoading = false;
                state.getTemplateCatInfo = payload;
                state.getTemplateCatSuccess = true;
            })
            .addCase(getTemplateCat.rejected, (state, { payload }) => {
                state.getTemplateCatLoading = false;
                state.getTemplateCatError = payload;
                state.getTemplateCatSuccess = false;
            });
    }
})

export default templateSlice.reducer;